import React from 'react';

import cn from 'classnames';
import Link from 'next/link';

import { Button, Tag } from '@components/Element';
// import Icon from '@components/Icon';
import { NumberRolling } from '@components/NumberRolling';
import {
  AIRDROP_PATHS
  // MARKET_PATHS
} from '@constants/index';
import { useClient } from '@lib/hooks';
import { I18n } from '@utils/index';

import styles from './index.module.less';

// export const Tag: React.FC = () => {
//   return (
//     <div>
//       <Icon name="theFire" className={styles.icon} />
//       <div>火热进行中</div>
//     </div>
//   );
// };

interface HeaderInfoProps {
  amount: string;
}

export const HeaderInfo: React.FC<HeaderInfoProps> = (props) => {
  const { amount } = props;
  const isPc = useClient();
  return (
    <div>
      <div className={styles.row1}>
        <div className={cn(styles.KikiAirdrop, 'DINPro-Medium')}>
          {I18n.t('GMtuLIKC')}
        </div>
        <Tag
          text={I18n.t('eeCUEcGf')}
          iconName="theFire"
          className={styles.tag}
          textClass={styles.tagText}
          iconClass={styles.tagIcon}
        />
      </div>
      <div className={styles.row2Container}>
        <div className={styles.row2}>
          <div className={cn(styles.row2Text, 'DINPro-Medium')}>{I18n.t('eBiz2KWb')}</div>
        </div>
      </div>

      <div className={cn(styles.row3, 'DINPro-Medium')}>
        ≈&nbsp;
        <NumberRolling
          number={amount || '0'}
          color={'#fff'}
          fontFamily="DINPro-Medium"
          fontSize={isPc ? 32 : 16}
        />
        &nbsp;USD
      </div>
      <div className={cn(styles.row4, 'DINPro')}>{I18n.t('x9LIktj0')}</div>
      <div>
        <Link legacyBehavior href={AIRDROP_PATHS.SEND} passHref>
          <a>
            <Button data-buried="send-airdrop" className={cn(styles.airdropBtn, 'Medium')}>
              <div>{I18n.t('PAnz7JcB')}</div>
            </Button>
          </a>
        </Link>
        {/* <Link legacyBehavior href={MARKET_PATHS.MARKET} passHref>
          <a>
            <div className={cn(styles.toTrade, 'DINPro')} data-buried="to-trade">
              {I18n.t('go_to_trade')}<Icon name="toTheRight" className={styles.toTheRight} />
            </div>
          </a>
        </Link> */}
      </div>
    </div>
  );
};
